﻿import React from 'react';
import {BuyNowLinkModel} from "../../product-models";
import BuyNowLink from "./BuyNowLink";
import { i18n, i18nArray } from "../../helpers/localisation-helpers";
import { useTypedSelector } from "../../hooks/useTypeSelector";


interface BuyNowLinksProps {
    buyNowLinks: BuyNowLinkModel[];
}


const BuyNowLinks = (props:BuyNowLinksProps) => {
    
    if(props.buyNowLinks == undefined || props.buyNowLinks.length == 0) {
        return null;
    }

    const { productData } = useTypedSelector((state) => state.product);
    
    return (
        <div className="buy-now-links">
            <div className="onepcssgrid-1300" style={{overflow: "hidden"}}>
                <div className="onerow">
                    <div className="col12 last">
                        <h3>
                            <a id="buynow">
                                {i18n("Resource.BuyNow", productData.PageLocalisations)}
                            </a>
                        </h3>
                        {props.buyNowLinks.length > 0 && props.buyNowLinks.map((buyNowLink, index) => {
                            return (
                                <BuyNowLink key={index} 
                                            imageHash={buyNowLink.ImageHash} 
                                            resellerName={buyNowLink.ResellerName} 
                                            overlayText={buyNowLink.OverlayText} 
                                            url={buyNowLink.Url} 
                                            imageUrl={buyNowLink.ImageUrl} 
                                />
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BuyNowLinks